import { SP360Logo } from 'assets';
import Skeleton from 'components/Skeleton';
import callApi from 'lib/callApi';
import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';

import styles from './styles.module.css';
import history from '../../history';

const UnderMaintenance = () => {
  const [estimatedCompletionDate, setEstimatedCompletionDate] = useState(null);
  const [customMessage, setCustomMessage] = useState('');
  const [maintenanceModeEnabled, setMaintenanceModeEnabled] = useState(false);
  const [timeLeft, setTimeLeft] = useState({});

  const fetchMaintenanceStatus = async () => {
    let url = '/healthcheck/';
    await callApi(url, 'GET')
      .then((res) => {
        localStorage.removeItem('maintenanceEnabled');
        history.push('/');
      })
      .catch((err) => {
        if (err?.status === 503) {
          const {
            maintenanceEnabled,
            maintenanceMessage,
            maintenanceEndDateTime,
          } = err.data;
          // Only update the state if the previous state is different
          setMaintenanceModeEnabled(maintenanceEnabled);
          setCustomMessage(maintenanceMessage);
          if (estimatedCompletionDate !== maintenanceEndDateTime) {
            setEstimatedCompletionDate(maintenanceEndDateTime);
          }
          // Only update the state if the previous state is different
          const newTimeLeft = calculateTimeLeft(maintenanceEndDateTime);
          if (JSON.stringify(timeLeft) !== JSON.stringify(newTimeLeft)) {
            setTimeLeft(newTimeLeft);
          }
        }
      });
  };

  useEffect(() => {
    fetchMaintenanceStatus();
    const interval = setInterval(fetchMaintenanceStatus, 10 * 60 * 1000); // 10 minutes
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (estimatedCompletionDate) {
      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft(estimatedCompletionDate));
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [estimatedCompletionDate]);

  const calculateTimeLeft = (endDate) => {
    const difference = +new Date(endDate) - +new Date();
    if (difference <= 0) return {};

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  const timerComponents = Object.keys(timeLeft).map((interval) => (
    <div key={interval} className={styles.countdownItem}>
      <span className={styles.countdownNumber}>{timeLeft[interval]}</span>
      <span className={styles.countdownLabel}>{interval}</span>
    </div>
  ));

  return (
    <div className={styles.maintenanceContainer}>
      <Row className="justify-content-center align-items-center text-center">
        <Col>
          <div className={styles.maintenanceContent}>
            <img
              alt="logo"
              className={styles.maintenanceLogo}
              src={SP360Logo}
            />
            <h1 className={styles.maintenanceHeader}>
              System Under Maintenance
            </h1>
            {estimatedCompletionDate ? (
              <p className={styles.customMessage}>{customMessage}</p>
            ) : (
              <div
                className="d-flex justify-content-center"
                style={{ marginBottom: '1.5rem' }}
              >
                <div className="d-flex flex-column align-items-start">
                  <Skeleton
                    height="1em"
                    width="15em"
                    rounded="md"
                    style={{ marginBottom: '8px' }}
                  />
                  <Skeleton
                    height="1em"
                    width="12em"
                    rounded="md"
                    style={{ marginBottom: '8px' }}
                  />
                  <Skeleton height="1em" width="15em" rounded="md" />
                </div>
              </div>
            )}
            <p className={styles.maintenanceText}>
              Security Program 360 is expected to be available in:
            </p>
            <div className={styles.countdown}>
              {timerComponents.length ? (
                timerComponents
              ) : estimatedCompletionDate ? (
                <span>Time's up! We'll be back shortly.</span>
              ) : (
                <div className="d-flex justify-content-center">
                  <Skeleton
                    height="4.5em"
                    rounded="md"
                    width="4em"
                    style={{ marginRight: '10px' }}
                  />
                  <Skeleton
                    height="4.5em"
                    rounded="md"
                    width="4em"
                    style={{ marginRight: '10px' }}
                  />
                  <Skeleton
                    height="4.5em"
                    rounded="md"
                    width="4em"
                    style={{ marginRight: '10px' }}
                  />
                  <Skeleton
                    height="4.5em"
                    rounded="md"
                    width="4em"
                    style={{ marginRight: '10px' }}
                  />
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UnderMaintenance;
